import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function getEventNcourKiboNtust(sanitizer: DomSanitizer): Block[] {
    return [
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_2.jpg",
        blockImgName: "",
        blockIndex: 0,
        blockName: "block1",
        blockType: 8,
        content: null,
        id: 1,
        imgLink: null,
        imgPosition: null,
        subtitle: null,
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 1,
        blockName: "block2",
        blockType: 3,
        content: null,
        id: 2,
        imgLink: null,
        imgPosition: null,
        title: "面對下一場震盪，誰先準備好未來？<br>碩達捐贈臺科大N-Cour永續淨零平台，打造數位永續共好起點",
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">從川普新關稅陰影到台灣限空令衝擊，企業如何不再只是被動應對？</p>'
        ),
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 2,
        blockName: "block3",
        blockType: 3,
        content: null,
        id: 5,
        imgLink: null,
        imgPosition: null,
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 18px; text-align: left; color: black;">【2025年4月15日】<br>圖片提供: 臺科大、碩達系統<br><br>當全球再度陷入不確定的經濟與政治旋渦，新一輪關稅威脅，引發全球供應鏈緊張，台灣市場瞬間感受到壓力波動，企業界再次意識到：<b>全球政經格局的不確定性，正在逼近每一家企業的治理底線。</b><br>但危機的背後，也正是啟動轉型的新起點。<br><b>碩達系統與國立臺灣科技大學</b>聯合舉辦<b>【數位賦能 × 減碳共力：碳盤查平台捐贈儀式暨淨零論壇】</b>，這是一場結合<b>數位 × 永續 × 教育 × 生態共好</b>的前瞻聯盟，強調企業不該只是反應法規、應付壓力，而是應該主動成為下一個規則的設計者。</p>'
        ),
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_3.jpg",
        blockImgName: "",
        blockIndex: 3,
        blockName: "block4",
        blockType: 5,
        content: null,
        id: 1,
        imgLink: null,
        imgPosition: null,
        subtitle: sanitizer.bypassSecurityTrustHtml("(圖)臺科大碳盤系統捐贈儀式: (左)碩達系統執行長陳相宇 (右)臺科大校長顏家鈺"),
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_4.jpg",
        blockImgName: "NCour_NTUST_4.jpg",
        blockIndex: 4,
        blockName: "block5",
        blockType: 6,
        content: sanitizer.bypassSecurityTrustHtml(
            '<p style="color: #2681bd; font-size: 22px">未來不是交接，而是共寫：從教育現場啟動永續人才</p>' +
                '<p style="font-size: 20px; color: black;">「我們不再等待命令，而是用行動參與未來設計。我們今天捐贈的，不只是一套系統，而是一份參與未來設計的邀請。從企業到校園，從數據到責任，從流程到文化，我們希望打造一個真正以『雙軸轉型』為核心、能持續進化的共好生態系。」—碩達系統執行長陳相宇如是說。</p>' +
                '<p style="font-size: 20px; color: black; margin-top: 20px">這場活動不僅是產學合作的里程碑，更是一項為未來佈局的策略啟動—企業必須從「治理思維」出發，強化自身在永續管理與數據落實上的韌性，才可能在劇變中站穩腳步。臺科大校長顏家鈺亦表示：「很榮幸能與碩達系統合作，這不僅是軟體技術的引入，更是產學信任與價值的對接。我們期待透過此合作推動更多橫向資源整合、縱向教學落地，從校園出發，實踐台灣在國際永續競爭中的新角色。」</p>'
        ),
        id: 3,
        imgLink: null,
        imgPosition: "left",
        subtitle: null,
        title: null,
        imgInfo: sanitizer.bypassSecurityTrustHtml('<span style="font-size: 16px">捐贈致詞: 碩達系統執行長陳相宇</span>'),
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_5.jpg",
        blockImgName: "NCour_NTUST_5.jpg",
        blockIndex: 5,
        blockName: "block6",
        blockType: 6,
        content: sanitizer.bypassSecurityTrustHtml(
            '<p style="color: #2681bd; font-size: 22px">對應時勢：不是誰跑得快，而是誰站得穩</p>' +
                '<p style="font-size: 20px; color: black;">臺科大工管系郭財吉主任指出：「碳盤查的挑戰不只是技術，而是組織能不能承接轉型責任。」此次攜手碩達產學合作，不僅是平台導入，而是一場從教育、技術、管理三軸整合的轉型實驗，也是為未來 SDGs以及ESG 行動規範培育出有備而來的人才與機制。</p>'
        ),
        id: 3,
        imgLink: null,
        imgPosition: "left",
        subtitle: null,
        title: null,
        imgInfo: sanitizer.bypassSecurityTrustHtml('<span style="font-size: 16px">(圖)淨零論壇: 臺科大工管系主任郭財吉</span>'),
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 6,
        blockName: "block7",
        blockType: 3,
        content: null,
        id: 2,
        imgLink: null,
        imgPosition: null,
        title: "從平台到生態：以人為本的數據治理",
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">碩達提出「C-4碳知決策架構：人 × 流程 × 數據 × 權責」，不是為了自動化而自動，而是讓每一筆資料的產生都有責任、脈絡與信任依據，打造能夠跨越十年、穿越風險的永續骨幹。「AI很強，但錯的數據會讓它成為風險放大器，而我們是在為它打造穩定的地基。」從實務痛點出發，打造企業級碳治理新基準，這不僅是平台導入，更是一套「轉型邏輯」的交接—以人為本、從責任出發，打破「為填報而填報」的任務導向，協助企業與校園從根本落實信任、決策與文化的重塑。</p>'
        ),
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_6.jpg",
        blockImgName: "NCour_NTUST_6.jpg",
        blockIndex: 7,
        blockName: "block8",
        blockType: 6,
        content: sanitizer.bypassSecurityTrustHtml(
            '<p style="color: #2681bd; font-size: 22px">從宣言到實踐，全面啟動永續新章</p>' +
                '<p style="font-size: 20px; color: black;">此次活動共集結六大精彩環節，從校方淨零宣示到AI賦能轉型、企業永續數據驅動策略、半導體產業實戰碳管理分享、以及企業落地解方；由校長顏家鈺啟動臺科大淨零宣言，展現臺科大對永續發展與淨零碳排的堅定承諾，強調臺科大將以科技創新、教育研究與產學合作為核心驅動力，致力於2049年前實現淨零排放目標。接續由臺科大工管系主任郭財吉教授接力進行專題演講，分享AI如何輔助永續治理，探討全球ESG轉型浪潮中，AI如何成為策略加速器。碩達系統賴珈榕與陳維堯兩位經理突破以往研討會模式，採雙講者形式以實境剖析，從底層流程重塑碳管理思維，<b>強調「起步即正確」的設計哲學，賴經理表示： 「N-Cour不僅是技術平台，更是一場轉型邏輯的共創。」</b></p>'
        ),
        id: 3,
        imgLink: null,
        imgPosition: "left",
        subtitle: null,
        title: null,
        imgInfo: sanitizer.bypassSecurityTrustHtml('<span style="font-size: 16px">(圖)淨零論壇: 碩達系統經理賴珈榕</span>'),
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 8,
        blockName: "block9",
        blockType: 3,
        content: null,
        id: 5,
        imgLink: null,
        imgPosition: null,
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 20px; text-align: left; color: black;">而福懋科技永續部門專員吳晉德更是從自身出發，分享產業如何執行碳管理營運策略以及推動永續的起心動念。最後由碩達系統技術顧問洪郡澤展示生態夥伴綠色解方，協助不同規模企業數位賦能精準起步；現場更安排臺科大永續中心的SDGs成果、國際環境資料庫專家中崗科技的方案介紹以及N-Cour永續淨零平台展示，現場實務經驗交流迴響熱絡，參與來賓亦表示企業正是需要系統以ERP的邏輯進行管理，因為碳務也是企業資源，未來也將成為企業經營管理重要的一環。本次活動從理論啟發到實務案例，完整鋪陳台灣邁向永續治理的多元樣貌，展示從校園、產業到系統整合的完整鏈結。</p>'
        ),
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 6,
        blockName: "block10",
        blockType: 3,
        content: null,
        id: 2,
        imgLink: null,
        imgPosition: null,
        title: "對未來的承諾，不只是儀式，而是行動的開始",
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">這場捐贈不只是產品交付或技術移轉，更是台灣產業、教育與社會的一次集體起步。從校園播下數位永續的種子，讓產業不再孤軍奮戰，讓人才培育與實務鏈結。這不僅是一項合作，更是一場「文化重塑的預告」。</p>' +
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px"><b>「你不一定要跑得最快，但你一定要知道為什麼出發。」</b></p><br>' +
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">在全球永續與數位治理成為主流的新時代，<b>「起步是否正確」</b>，決定了未來能不能走得長遠。碩達系統執行長強調，未來將持續推動數位工具與產業治理深度整合，讓更多企業與校園能在 N-Cour 永續淨零平台上共建知識節奏、共享轉型成果，打造一個能夠真正對齊未來的新型永續文化。</p>'
        ),
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 6,
        blockName: "block11",
        blockType: 4,
        content: null,
        id: 2,
        imgLink: null,
        imgPosition: null,
        title: "更多現場精彩活動照片:",
        subtitle: null,
        imgInfo: null,
        multipleImg: [
            { imgLink: null, img: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_7.jpg", info: "(圖)淨零論壇:  碩達系統技術顧問洪郡澤" },
            { imgLink: null, img: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_8.jpg", info: "(圖)淨零論壇: (左)技術經理陳維堯 (右)經理賴珈榕" },
            { imgLink: null, img: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_10.jpg", info: "(圖)淨零論壇:  碩達系統團隊與臺科大工管系主任郭財吉合照" },
            { imgLink: null, img: "", info: "" },
        ],
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: null,
        blockImgName: null,
        blockIndex: 8,
        blockName: "block12",
        blockType: 3,
        content: null,
        id: 5,
        imgLink: null,
        imgPosition: null,
        subtitle: sanitizer.bypassSecurityTrustHtml(
            '<p style="font-size: 20px; text-align: left; color: black;">新聞刊登：</p>' +
                '<p style="font-size: 20px; text-align: left; color: black;">中央社平台，<a href="https://www.cna.com.tw/postwrite/chi/399270" target="_blank" style="display: inline; word-break: break-all;">https://www.cna.com.tw/postwrite/chi/399270</a></p>' +
                '<p style="font-size: 20px; text-align: left; color: black;">PCHOME新聞，<a href="https://news.pchome.com.tw/living/cna/20250417/index-17448527496045318009.html" target="_blank" style="display: inline; word-break: break-all;">https://news.pchome.com.tw/living/cna/20250417/index-17448527496045318009.html</a></p>' +
                '<p style="font-size: 20px; text-align: left; color: black;">蕃新聞，<a href="https://n.yam.com/Article/20250417177026" target="_blank" style="display: inline; word-break: break-all;">https://n.yam.com/Article/20250417177026</a></p>' +
                '<p style="font-size: 20px; text-align: left; color: black;">MSN新聞，<a href="https://pse.is/7fhzck" target="_blank" style="display: inline; word-break: break-all;">https://pse.is/7fhzck</a></p>'
        ),
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "/assets/img/blog/N-Cour/NTUST/NCour_NTUST_1.jpg",
        blockImgName: "",
        blockIndex: 0,
        blockName: "block13",
        blockType: 8,
        content: null,
        id: 1,
        imgLink: null,
        imgPosition: null,
        subtitle: null,
        title: null,
        imgInfo: null,
    },
    {
        backImg: null,
        backImgName: null,
        blockImg: "",
        blockImgName: "",
        blockIndex: 0,
        blockName: "block14",
        blockType: 8,
        content: null,
        id: 1,
        imgLink: null,
        imgPosition: null,
        subtitle: null,
        title: null,
        imgInfo: null,
    },
    ];
}
